export type Tone = "ok" | "warn" | "bad" | "active" | "neutral";

/** Status tone → { bg, fg } pairs, matching Handoff §9 exactly. */
export const TONE: Record<Tone, { bg: string; fg: string }> = {
  ok: { bg: "#e8f4ee", fg: "#1f8a5b" },
  warn: { bg: "#fbf2dc", fg: "#9a6a12" },
  bad: { bg: "#fbe9e7", fg: "#b3261e" },
  active: { bg: "#e8f0f3", fg: "#2a6f8a" },
  neutral: { bg: "#f0efe9", fg: "#6b706a" },
};

export const HEALTH_DOT: Record<"ok" | "warn" | "bad", string> = {
  ok: "#1f8a5b",
  warn: "#c0612f",
  bad: "#b3261e",
};

export const PRIORITY_DOT: Record<"low" | "normal" | "high" | "urgent", string> = {
  low: "#bcbfba",
  normal: "#8a8e88",
  high: "#c0612f",
  urgent: "#b3261e",
};

/** Lucide icon name for each channel. */
export const CHANNEL_ICON: Record<string, string> = {
  form: "clipboard-list",
  email: "mail",
  phone: "phone",
  sms: "message-square",
  chat: "messages-square",
  escalation: "git-branch",
  internal: "shield",
};

export const CHANNEL_LABEL: Record<string, string> = {
  form: "Web form",
  email: "Email",
  phone: "Phone",
  sms: "Text",
  chat: "Live chat",
  escalation: "Escalation",
  internal: "Internal",
};
